import { createContext } from 'react';

export interface GWPDrawerContextValue {
	titleId: string;
	descriptionId: string;
	registerTitle: (nextValue: boolean) => void;
	registerDescription: (nextValue: boolean) => void;
}

const GWPDrawerContext = createContext<GWPDrawerContextValue | null>(null);

export default GWPDrawerContext;
